module.exports = __webpack_public_path__ + "static/media/DoctorFemale.d5a50dbf.gif";